import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import MobileMenu from "./MobileMenu";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { ContactModal } from "./ContactModal";

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Change background on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const openContactModal = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        isScrolled ? "bg-background/80 backdrop-blur-md py-1" : "bg-transparent py-2"
      }`}>
        <div className="container mx-auto px-4 flex items-center justify-between">
          {/* Logo */}
          <NavLink to="/" className="flex items-center flex-shrink-0">
            <img src="/logo.svg" alt="Koech Creatives" className="h-8 w-auto" />
            <span className="ml-2 text-base font-semibold text-foreground font-sans">Koech Creatives</span>
          </NavLink>

          {/* Desktop Navigation - Centered */}
          <div className="hidden md:flex items-center justify-center space-x-8 font-sans mx-auto">
            <NavLink 
              to="/" 
              className={({ isActive }) => 
                `nav-link ${isActive ? 'text-primary after:w-full' : ''}`
              }
            >
              Home
            </NavLink>
            <NavLink 
              to="/mobile-app-designs" 
              className={({ isActive }) => 
                `nav-link ${isActive ? 'text-primary after:w-full' : ''}`
              }
            >
              Mobile Apps
            </NavLink>
            
            <NavLink 
              to="/logo-designs" 
              className={({ isActive }) => 
                `nav-link ${isActive ? 'text-primary after:w-full' : ''}`
              }
            >
              Logo Designs
            </NavLink>
            <NavLink 
              to="/flyer-designs" 
              className={({ isActive }) => 
                `nav-link ${isActive ? 'text-primary after:w-full' : ''}`
              }
            >
              Flyer Designs
            </NavLink>
            <NavLink 
              to="/ux-designs" 
              className={({ isActive }) => 
                `nav-link ${isActive ? 'text-primary after:w-full' : ''}`
              }
            >
              UX Designs
            </NavLink>
          </div>

          {/* Build With Us Button - Desktop */}
          <div className="hidden md:block relative">
            <div 
              className="relative"
              onMouseEnter={() => setIsButtonHovered(true)}
              onMouseLeave={() => setIsButtonHovered(false)}
            >
              {isButtonHovered && (
                <motion.div
                  className="absolute inset-0 rounded-full bg-transparent border-2 border-coral"
                  animate={{ scale: [1, 1.2, 1], opacity: [0.8, 0.2, 0] }}
                  transition={{ duration: 1.5, repeat: Infinity, repeatDelay: 0 }}
                />
              )}
              <motion.button 
                onClick={openContactModal}
                className="relative flex items-center bg-transparent text-white border-2 border-coral rounded-full py-2 px-4 transition-colors hover:bg-coral/10 z-10"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
              >
                <MessageCircle className="w-4 h-4 mr-2" />
                Build with us
              </motion.button>
            </div>
          </div>

          {/* Mobile Actions */}
          <div className="flex items-center space-x-3 md:hidden">
            {/* Mobile Build With Us Button */}
            <button 
              onClick={openContactModal}
              className="flex items-center bg-transparent text-white border-2 border-coral rounded-full py-1 px-3 text-sm"
            >
              <MessageCircle className="w-3 h-3 mr-1" />
              <span className="text-white text-sm">Build with us</span>
            </button>

            {/* Mobile Menu Button */}
            <button 
              onClick={toggleMobileMenu}
              className="text-foreground" 
              aria-label="Toggle menu"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={closeMobileMenu} openContactModal={openContactModal} />
      
      {/* Contact Modal */}
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Navigation; 